var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"action-btn",attrs:{"type":"button","disabled":_vm.loading}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[_vm._v(_vm._s(_vm.text))]),_c('ClipLoader',{attrs:{"loading":_vm.loading,"color":'#fff',"size":'20px'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }